
define('tmpl!core/templates/webidl-contiguous/iterable.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlIterable\' id="{{obj.idlId}}" data-idl data-title=\'iterable\'>{{extAttr obj indent\n}}{{idn indent}}{{qualifiers}}{{#tryLink obj}}iterable{{/tryLink\n}}&lt;{{idlType obj}}&gt;;</span>\n');});

